// File: frontend/src/components/ProtectedRoute.jsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ allowedRoles = [], children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  try {
    // If auth state is still loading, display loading spinner
    if (loading) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
            <p className="text-slate-500 text-sm font-medium">Verifying access...</p>
          </div>
        </div>
      );
    }

    // Check if user is authenticated
    if (!isAuthenticated()) {
      return <Navigate to="/login" replace />;
    }

    // Check if allowedRoles is specified and whether user's role matches
    if (allowedRoles.length > 0) {
      const userRole = user?.role?.toLowerCase();
      const hasRoleMatch = allowedRoles.some(
        (role) => role.toLowerCase() === userRole
      );

      if (!hasRoleMatch) {
        return <Navigate to="/unauthorized" replace />;
      }
    }

    // Render child elements if authorized
    return children;
  } catch (error) {
    console.error('Error rendering ProtectedRoute:', error);
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;
